import React, { useEffect, useState, useContext } from "react";
import MaterialTable from 'material-table';
//import { apiCall } from '../../../common/apiconfig';
import { Route, Switch, Link, BrowserRouter as Router, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
//import { Paginationn } from '../../../../common/pagination'
//import { appConfig } from "../../../../common/constants";
import CircularProgress from '@material-ui/core/CircularProgress';
import { HekmaTextSearchField } from '../../../../globalcomponents/formElements';
import InputAdornment from '@material-ui/core/InputAdornment';
// import * as R_Items from '../recentItems';
import SearchIcon from '@material-ui/icons/Search';

// import { genericApi } from '../../../common/apiconfig';
import { NavSubMenu } from '../../navMenu';
import Registered from './registeredstudies'
import Nonregistered from './nonRegisteredstudies'
import ExecutedStudies from './executedStudies'

const menus = [
  {
    to: "/site/accountDetails/fees/registeredstudies",
    text: "Registered Studies"
  },
  {
    to: "/site/accountDetails/fees/nonRegisteredstudies",
    text: "Non-Registered Studies"
  },
  {
    to: "/site/accountDetails/fees/executedStudies",
    text: "Executed Studies"
  }
]


function Fees(props) {
  const [offset, setoffset] = useState(0)
  const [data, setData] = useState([])
  const [searchData, setSearchData] = useState([])
  let [progress, setProgress] = useState(false);
  let [valSearch, setValSearch] = useState('');

  // useEffect(() => {
  //   getApiData();
  // }, []);
  useEffect(() => {
    // getApiData()
  }, [])


  return (
    <>
      {progress && <div className="fullScreen">
        <CircularProgress
          disableShrink
          className="progressCircle"
          value={90}
          size={100}
          thickness={1.5}
        />
      </div>}
      <div className="d-flex">
        {/* <div class="secondary-header mr-auto">Subjects</div> */}
      </div>
      <section className="mb-3">
        <NavSubMenu menus={menus} />
      </section>

      <div className="">
        <Switch>
          <Route exact path="/site/accountDetails/fees/registeredstudies">
            <Registered />
          </Route>
          <Route exact path="/site/accountDetails/fees/nonRegisteredstudies">
            <Nonregistered />
          </Route>
          {/* <Route exact path="/site/accountDetails/fees/executedStudies">
            <ExecutedStudies />
          </Route> */}

          <Redirect to="/site/accountDetails/fees/registeredstudies" />
        </Switch>
      </div>
    </>
  )

}
const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateFormField: (obj) => {
      return dispatch(
        {
          type: 'UpdateFormField',
          value: obj.value,
          name: obj.name
        }
      )
    },
    updateErrorObj: (obj) => {
      return dispatch(
        {
          type: 'updateErrorObj',
          flag: obj.flag,
          name: obj.name,
          text: obj.text
        }
      )
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Fees);

